import { render, staticRenderFns } from "./TicketAddress.vue?vue&type=template&id=36f740f8&scoped=true&"
import script from "./TicketAddress.vue?vue&type=script&lang=js&"
export * from "./TicketAddress.vue?vue&type=script&lang=js&"
import style0 from "./TicketAddress.vue?vue&type=style&index=0&id=36f740f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f740f8",
  null
  
)

export default component.exports